<span euiIcon
      euiSize2XL
      iconClass="eui-icon-ecl-hamburger"
      (click)="onToggleSidebar($event)">
</span>

<!--
Removed : attr.aria-label="{{ (asService.state$ | async).isSidebarOpen ? 'Close Icon' : 'Bars Icon' }}"
Title: WCAG 4.1.2: Ensures ARIA attributes are allowed for an element's role (.eui-icon-ecl-hamburger)
Tags: Accessibility, WCAG 4.1.2, aria-allowed-attr

Issue: Ensures ARIA attributes are allowed for an element's role (aria-allowed-attr - https://accessibilityinsights.io/info-examples/web/aria-allowed-attr)
Target application: eUI - UX - http://localhost:4600/style-guide-next/components/eui-card
Element path: .eui-icon-ecl-hamburger
Snippet: <span euiicon="" iconclass="eui-icon-ecl-hamburger" ng-reflect-icon-class="eui-icon-ecl-hamburger" aria-label="Close Icon" class="eui-icon eui-icon-ecl-hamburger"></span>

How to fix:
Fix all of the following:
  ARIA attribute cannot be used: aria-label

Environment: Chrome version 90.0.4430.93

====

This accessibility issue was found using Accessibility Insights for Web 2.26.0 (axe-core 4.2.0), a tool that helps find and fix accessibility issues. Get more information & download this tool at http://aka.ms/AccessibilityInsights.
-->
